import { Gender } from '@/app/shared/enums';
import { AddressBillingModel, ContactBillingModel } from '@/app/shared/models';
import { Model } from '@/app/shared/models/model';

export class CustomerBillingModel extends Model {
  public Name!: string;
  public Document?: string;
  public DocumentType!: string;
  public Birthdate!: string;
  public Gender!: Gender;

  public Addresses!: AddressBillingModel[];
  public Contacts!: ContactBillingModel[];
}
